import { ResolvedBodyMapEntriesScreen } from "app/screens/residents/show/ResolvedBodyMapEntriesScreen";

export default function ResolvedBodyMapEntriesPage() {
  return <ResolvedBodyMapEntriesScreen />;
}
